import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import NewBlog from './pages/NewBlog';
import BlogDetail from './pages/BlogDetail';
import EditBlog from './pages/EditBlog';
import PreviewBlog from './pages/PreviewBlog';
import CreditCardPage from './pages/CreditCardPage';

// ...


function App() {
  const [blogs, setBlogs] = useState([]);

  return (
    <Routes>
      <Route path="/" element={<Home blogs={blogs} setBlogs={setBlogs} />} />
      <Route
        path="/:type/new"
        element={<NewBlog blogs={blogs} setBlogs={setBlogs} />}
      />
      <Route
        path="/blogs/:slug"
        element={<BlogDetail blogs={blogs} setBlogs={setBlogs} />}
      />
      <Route
        path="/blogs/edit/:slug"
        element={<EditBlog blogs={blogs} setBlogs={setBlogs} />}
      />
      <Route path="/PreviewBlog" element={<PreviewBlog />} />
      <Route path="/credit-cards" element={<CreditCardPage />} />
    </Routes>
  );
}

export default App;
